export const CheckCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="m429-438-60-59q-11-11-25-11t-25 11q-11 11-11 25.5t11 25.5l85 85q11 11 25 11t25-11l187-187q11-11 11-25.5T641-599q-11-11-25-11t-25 11L429-438Zm51 342q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
  </svg>
);

export const PodcastIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M444-132v-286q-17-9-26.5-25.5T408-480q0-30 21-51t51-21q30 0 51 21t21 51q0 20-9.5 36.5T516-418v286q0 15-10.5 25.5T480-96q-15 0-25.5-10.5T444-132ZM234-234q-11 11-26.5 10T182-237q-41-51-63.5-112.5T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 69-22.5 131T777-237q-10 12-25.5 12.5T725-235q-11-11-11-25.5t10-26.5q32-40 50-89t18-104q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 55 17.5 104t49.5 90q9 12 9.5 26.5T234-234Zm102-102q-11 11-26 10.5T286-338q-22-30-34-66t-12-76q0-100 70-170t170-70q100 0 170 70t70 170q0 40-12.5 76.5T672-337q-9 11-23 11.5T624-336q-11-11-11-25t8-27q13-20 20-43t7-49q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 26 7 49t20 43q8 13 8 27t-11 25Z" />
  </svg>
);

export const DeviceHubIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M144-180v-120q0-15.3 10.35-25.65Q164.7-336 180-336h123l141-155v-91q-37-13-60.5-44.12Q360-657.23 360-696q0-50 35-85t85-35q50 0 85 35t35 85q0 39-23.5 70T516-582v91l141 155h123q15.3 0 25.65 10.35Q816-315.3 816-300v120q0 15.3-10.35 25.65Q795.3-144 780-144H660q-15.3 0-25.65-10.35Q624-164.7 624-180v-85L480-423 336-265v85q0 15.3-10.35 25.65Q315.3-144 300-144H180q-15.3 0-25.65-10.35Q144-164.7 144-180Z" />
  </svg>
);

export const InsertChartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm0-72h528v-528H216v528Zm0-528v528-528Zm108.21 168q-15.21 0-25.71 10.35T288-540v216q0 15.3 10.29 25.65Q308.58-288 323.79-288t25.71-10.35Q360-308.7 360-324v-216q0-15.3-10.29-25.65Q339.42-576 324.21-576Zm156-96q-15.21 0-25.71 10.35T444-636v312q0 15.3 10.29 25.65Q464.58-288 479.79-288t25.71-10.35Q516-308.7 516-324v-312q0-15.3-10.29-25.65Q495.42-672 480.21-672Zm156 240q-15.21 0-25.71 10.32-10.5 10.33-10.5 25.59v71.83q0 15.26 10.29 25.76 10.29 10.5 25.5 10.5t25.71-10.32q10.5-10.33 10.5-25.59v-71.83q0-15.26-10.29-25.76-10.29-10.5-25.5-10.5Z" />
  </svg>
);

export const TrendingUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M122-223q-11-11-11.5-25.5T121-274l205-205q21-21 51-21t51 21l101 101 212-211h-81q-15.3 0-25.65-10.29Q624-609.58 624-624.79t10.35-25.71Q644.7-661 660-661h168q15.3 0 25.65 10.35Q864-640.3 864-625v168q0 15.3-10.29 25.65Q843.42-421 828.21-421t-25.71-10.06Q792-441.13 792-456v-82L580-326q-21 21-51 21t-51-21L377-428 173-223q-11 11-25.5 11T122-223Z" />
  </svg>
);

export const FactCheckIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M168-144q-29.7 0-50.85-21.15Q96-186.3 96-216v-528q0-29.7 21.15-50.85Q138.3-816 168-816h624q29.7 0 50.85 21.15Q864-773.7 864-744v528q0 29.7-21.15 50.85Q821.7-144 792-144H168Zm0-72h624v-528H168v528Zm199-71q15.3 0 25.65-10.29Q403-307.58 403-322.79t-10.35-25.71Q382.3-359 367-359H247q-15.3 0-25.65 10.29Q211-338.42 211-323.21t10.35 25.71Q231.7-287 247-287h120Zm215-175-25.82-26.1q-10.69-10.9-24.93-10.4-14.25.5-25.73 11.5Q495-476 495-461.5t10.81 25.31l51.38 51.38Q568-374 582.18-374q14.18 0 24.82-11l120-120q11-10.91 11-25.45Q738-545 727-556t-25.67-11q-14.66 0-25.33 11l-94 94Zm-215 18q15.3 0 25.65-10.29Q403-464.58 403-479.79t-10.35-25.71Q382.3-516 367-516H247q-15.3 0-25.65 10.29Q211-495.42 211-480.21t10.35 25.71Q231.7-444 247-444h120Zm0-156q15.3 0 25.65-10.29Q403-620.58 403-635.79t-10.35-25.71Q382.3-672 367-672H247q-15.3 0-25.65 10.29Q211-651.42 211-636.21t10.35 25.71Q231.7-600 247-600h120ZM168-216v-528 528Z" />
  </svg>
);

export const EmojiObjectsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M480-72q-26 0-49-12.5T397-120h-13q-30 0-51-21t-21-51v-150q-57-40-88.5-102T192-576q0-120 84-204t204-84q120 0 204 84t84 204q0 70-31.5 132T648-342v150q0 30-21 51t-51 21h-14q-11 23-33.5 35.5T480-72Zm-96-120h192v-48H384v48Zm0-96h192v-48H384v48Zm-38-120h110v-110l-72-72q-7-7-7-17t7-17q7-7 17-7t17 7l62 62 62-62q7-7 17-7t17 7q7 7 7 17t-7 17l-72 72v110h110q38-31 60-74.5t22-93.5q0-90-63-153t-153-63q-90 0-153 63t-63 153q0 49 22 93t60 75Zm134-154Zm0-38Z" />
  </svg>
);

export const TuneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M492.21-144q-15.21 0-25.71-10.35T456-180v-168q0-15.3 10.29-25.65Q476.58-384 491.79-384t25.71 10.35Q528-363.3 528-348v48h251.72q15.28 0 25.78 10.29 10.5 10.29 10.5 25.5t-10.35 25.71Q795.3-228 780-228H528v48q0 15.3-10.29 25.65Q507.42-144 492.21-144ZM180-228q-15.3 0-25.65-10.29Q144-248.58 144-263.79t10.35-25.71Q164.7-300 180-300h168q15.3 0 25.65 10.29Q384-279.42 384-264.21t-10.35 25.71Q363.3-228 348-228H180Zm144.21-132q-15.21 0-25.71-10.35T288-396v-48H180.26q-15.26 0-25.76-10.29-10.5-10.29-10.5-25.5t10.35-25.71Q164.7-516 180-516h108v-48q0-15.3 10.29-25.65Q308.58-600 323.79-600t25.71 10.35Q360-579.3 360-564v168q0 15.3-10.29 25.65Q339.42-360 324.21-360ZM468-444q-15.3 0-25.65-10.29Q432-464.58 432-479.79t10.35-25.71Q452.7-516 468-516h312q15.3 0 25.65 10.29Q816-495.42 816-480.21t-10.35 25.71Q795.3-444 780-444H468Zm144.21-132q-15.21 0-25.71-10.35T576-612v-168q0-15.3 10.29-25.65Q596.58-816 611.79-816t25.71 10.35Q648-795.3 648-780v48h132q15.3 0 25.65 10.29Q816-711.42 816-696.21t-10.35 25.71Q795.3-660 780-660H648v48q0 15.3-10.29 25.65Q627.42-576 612.21-576ZM180-660q-15.3 0-25.65-10.29Q144-680.58 144-695.79t10.35-25.71Q164.7-732 180-732h312q15.3 0 25.65 10.29Q528-711.42 528-696.21t-10.35 25.71Q507.3-660 492-660H180Z" />
  </svg>
);

export const ContactsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M228.29-72Q213-72 202.5-82.29t-10.5-25.5q0-15.21 10.34-25.71 10.35-10.5 25.64-10.5h503.73q15.29 0 25.79 10.29t10.5 25.5Q768-93 757.66-82.5 747.31-72 732.02-72H228.29Zm0-744q-15.29 0-25.79-10.29t-10.5-25.5q0-15.21 10.34-25.71 10.35-10.5 25.64-10.5h503.73q15.29 0 25.79 10.29t10.5 25.5q0 15.21-10.34 25.71-10.35 10.5-25.64 10.5H228.29ZM480-432q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM168-192q-29.7 0-50.85-21.16Q96-234.32 96-264.04v-432.24Q96-726 117.15-747T168-768h624q29.7 0 50.85 21.16Q864-725.68 864-695.96v432.24Q864-234 842.85-213T792-192H168Zm55-72q48-57 115-88.5T480-384q75 0 142 31.5T737-264h55v-432H168v432h55Zm106 0h302q-34-24-72.08-36t-79-12Q439-312 401-300t-72 36Zm151-240q-20.4 0-34.2-13.8Q432-531.6 432-552q0-20.4 13.8-34.2Q459.6-600 480-600q20.4 0 34.2 13.8Q528-572.4 528-552q0 20.4-13.8 34.2Q500.4-504 480-504Zm0 24Z" />
  </svg>
);

export const GroupIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M96-284q0-25.78 12.5-47.39T143-366q54-32 114.5-49T384-432q66 0 126.5 17T625-366q22 13 34.5 34.61T672-284v20q0 29.7-21.16 50.85Q629.68-192 599.96-192H167.72Q138-192 117-213.15T96-264v-20Zm696 92h-67q9-17 14-35.19 5-18.18 5-36.81v-20q0-42-19.5-78T672-421q39 8 75.5 21.5T817-366q22 13 34.5 34.67Q864-309.65 864-284v20q0 29.7-21.15 50.85Q821.7-192 792-192ZM384-480q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm336-144q0 60-42 102t-102 42q-8 0-15-.5t-15-2.5q25-29 39.5-64.5T600-624q0-41-14.5-76.5T546-765q8-2 15-2.5t15-.5q60 0 102 42t42 102ZM168-264h432v-20q0-6.47-3.03-11.76-3.02-5.3-7.97-8.24-47-27-99-41.5T384-360q-54 0-106 14t-99 42q-4.95 2.83-7.98 7.91-3.02 5.09-3.02 12V-264Zm216.21-288Q414-552 435-573.21t21-51Q456-654 434.79-675t-51-21Q354-696 333-674.79t-21 51Q312-594 333.21-573t51 21ZM384-264Zm0-360Z" />
  </svg>
);

export const ForumIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M864-183q0 24-22 33.5t-39-7.5l-82.83-82.91H360.03q-29.71 0-50.87-21.17Q288-282.26 288-312v-48h384q29.7 0 50.85-21.15Q744-402.3 744-432v-240h48q29.7 0 50.85 21.16Q864-629.67 864-599.96V-183ZM168-462l42-42h390v-288H168v330Zm-35.82 123Q118-339 107-348.5T96-375v-417q0-29.7 21.15-50.85Q138.3-864 168-864h432q29.7 0 50.85 21.15Q672-821.7 672-792v288q0 29.7-21.15 50.85Q629.7-432 600-432H240l-83 83q-5.32 5-11.52 7.5-6.21 2.5-13.3 2.5ZM168-504v-288 288Z" />
  </svg>
);

export const ScatterPlotIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M672-96q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102T672-96Zm.21-72Q702-168 723-189.21t21-51Q744-270 722.79-291t-51-21Q642-312 621-290.79t-21 51Q600-210 621.21-189t51 21ZM288-216q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm.21-72Q318-288 339-309.21t21-51Q360-390 338.79-411t-51-21Q258-432 237-410.79t-21 51Q216-330 237.21-309t51 21ZM432-528q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm.21-72Q462-600 483-621.21t21-51Q504-702 482.79-723t-51-21Q402-744 381-722.79t-21 51Q360-642 381.21-621t51 21ZM672-240ZM288-360Zm144-312Z" />
  </svg>
);

export const SellIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M843-399 562-117q-11 11-24 16t-27 5q-14 0-27-5t-24-16L116.7-460.3Q106-471 101-483.89T96-511v-281q0-29.7 21.15-50.85Q138.3-864 168-864h281q13.91 0 26.96 5 13.04 5 23.77 15.7L843-500q11 11 16 23.5t5 26.5q0 14-5.02 27.09Q853.96-409.83 843-399ZM511-168l281-281-343-343H168v281l343 343ZM264-636q25 0 42.5-17.5T324-696q0-25-17.5-42.5T264-756q-25 0-42.5 17.5T204-696q0 25 17.5 42.5T264-636Zm216 156Z" />
  </svg>
);

export const DevicesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M144-192q-20 0-34-14t-14-34q0-20 14-34t34-14h48v-408q0-29.7 21.15-50.85Q234.3-768 264-768h516q15.3 0 25.65 10.29Q816-747.42 816-732.21t-10.35 25.71Q795.3-696 780-696H264v408h168q20 0 34 14t14 34q0 20-14 34t-34 14H144Zm468.28 0q-15.28 0-25.78-10.34-10.5-10.34-10.5-25.63v-359.74q0-15.29 10.34-25.79t25.62-10.5h215.76q15.28 0 25.78 10.34 10.5 10.34 10.5 25.63v359.74q0 15.29-10.34 25.79T828.04-192H612.28ZM648-288h144v-264H648v264Zm0 0h144-144Z" />
  </svg>
);

export default CheckCircleIcon;
